/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./game-difficulty.vue?vue&type=template&id=b2f9a6e6&scoped=true&"
import script from "./game-difficulty.vue?vue&type=script&lang=js&"
export * from "./game-difficulty.vue?vue&type=script&lang=js&"
import style0 from "./game-difficulty.vue?vue&type=style&index=0&id=b2f9a6e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f9a6e6",
  null
  
)

export default component.exports